import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function SecaoListColunasDinamicasFilter() {
    const [filterCod, setFilterCod] = useState<FilterValuesProps>({
        property: 'idConfiguracaoPropriedade',
        operator: 'eq',
        value: null,
    });

    const [filterTag, setFilterTag] = useState<FilterValuesProps>({
        property: 'dsConfiguracao',
        operator: 'like',
        value: '',
    });

    return (
        <Filter
            filters={[
                { value: filterCod, setter: setFilterCod },
                { value: filterTag, setter: setFilterTag },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código"
                    value={filterCod.value}
                    onChange={(e) => setFilterCod((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 2 }}>
                <CissTextField
                    label="Nome do campo"
                    value={filterTag.value}
                    onChange={(e) => setFilterTag((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
